module.exports = __webpack_public_path__ + "img/avatar7.7284de33.png";